import FormButtonSubmit from './FormButtonSubmit';
import FormCheckbox from './FormCheckbox/FormCheckbox';
import FormDebug from './FormDebug';
import FormItem from './FormItem';
import FormItemGroup from './FormItemGroup';
import FormRadio from './FormRadio/FormRadio';
import FormSelect from './FormSelect/FormSelect';
import FormWrapper from './FormWrapper';

export default {
  FormWrapper,
  FormDebug,

  FormItem,
  FormItemGroup,
  FormButtonSubmit,

  FormCheckbox,
  FormRadio,
  FormSelect,
};
